// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PoweroffOutlinedSvg from "@fishx/icons-svg/es/asn/PoweroffOutlined";
import FishxIcon from '../components/FishxIcon';

var PoweroffOutlined = function PoweroffOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PoweroffOutlinedSvg
  }));
};

PoweroffOutlined.displayName = 'PoweroffOutlined';
export default React.forwardRef(PoweroffOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PoweroffOutlined.js
// module id = 3842
// module chunks = 0